export default __webpack_public_path__ + "static/dark-w-chckup-43d658ed77b03856b8b30fec1858a8de.png";